import * as React from 'react'
import { styled } from '@creditas/stylitas'

import { Card as CreditasCard } from '@creditas/card'

interface Card {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent) => void
}

const Card = styled(CreditasCard)<Card>`
  position: relative;
  text-align: center;
  user-select: none;
`

export { Card }
